import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getLimitersRequest = reatomAsync(() => {
  return API.counterApi
    .counterControllerGetCounters()
    .then((response) => response.data);
}, "getLimiters").pipe(withDataAtom([]), withIsLoadingAtom());

export const getActiveLimiterRequest = reatomAsync(() => {
  return API.counterApi
    .counterControllerGetCounters({
      validateStatus: (status) => status === 404 || status === 200,
    })
    .then((response) => {
      if (response.status === 404) return null;
      return response.data;
    });
}, "getActiveLimiter").pipe(withDataAtom([]));
